{
  "actionCannotBeUndone": "Denne handlingen kan ikke angres.",
  "activeMembers": "Aktive medlemmar",
  "addContact": "Legg til kontakt",
  "addInterestAreaInSettings": "Fann ingen interesseområde. Gå til <1>kontoinnstillingar</1> for å opprette nye.",
  "bankrupt": "Konkurs",
  "bisnode.balance": "Balanse",
  "bisnode.result": "Driftsresultat",
  "bisnode.revenue": "Omsetning",
  "bisnode.staffCosts": "Lønnskostnader",
  "brreg.addWithoutBrreg": "Legg til uten Brønnøysundsregistrene",
  "brreg.description": "Vi henter fram nøkkelopplysninger om alle virksomheter som pr. i dag er registrert i Brønnøysundregistrene. Du kan søke på navn, eller på organisasjonsnummer hvis du kjenner det.",
  "brreg.notFindingTheCompany.description": "Hvis du ønsker å registrere bedriften uten Brønnøysundsregisteret så kan du legge inn informasjonen manuelt.",
  "brreg.notFindingTheCompany.title": "Finner du ikke bedriften?",
  "brreg.notFound": "Ikkje funne i BRREG.",
  "brreg.searchHelpText": "Her kan du søke etter bedriftens navn, eller organisasjonsnummer.",
  "brreg.SearchHitOver20": "Søket gav mer enn {{ total }} treff. Her vises de {{ length }} første. Velg fra listen eller juster søket.",
  "brreg.SearchHits": "Søket gav {{ total }} treff.",
  "brreg.searchLabel": "Søk i Brønnøysundsregistrene",
  "brreg.searchPlaceholder": "Bedriftsnavn eller organisasjonsnummer",
  "brreg.searhcNoHits": "Søket ga 0 treff. Prøv å søke etter noe annet.",
  "brreg.somethingWentWrong": "Noe gikk galt, prøv å skrive inn en ny verdi.",
  "changeInNumberOfEmployees": "Endring i antal årsverk",
  "changeType": "Endre type",
  "changeType.error": "Kunne ikkje endre type. Vennlegst prøv igjen.",
  "collaborators": "Samarbeidspartnarar",
  "invoices": "Fakturering",
  "companyInformation": "Selskapsinformasjon",
  "companyInformation.update.error": "selskapsinformasjon. Vennlegst prøv igjen.",
  "companyNotFound": "Kunne ikkje finne bedrift!",
  "companyType": "Selskapsform",
  "companyTypeCode": "Selskapsform kode",
  "confirm.deletion": "Bekreft at du ønsker å slette desse.",
  "confirmDelete.associate.question": "Er du sikker på at du vil slette desse samarbeidspartnarane, og alle kontakter som er knytta til dei?",
  "confirmDelete.contact.question": "Er du siikker på at du vil slette desse kontaktene?",
  "confirmDelete.lead.question": "Er du sikker på at du vil slette desse leads, og alle kontakter som er knytta til dei?",
  "confirmDelete.member.question": "Er du sikker på at du vil slette desse medlemmane, og alle kontakter som er knytta til dei?",
  "confirmDeleteMembersQuestion": "Er du sikker på at du vil slette disse medlemmene, og alle kontakter som er knyttet til med?",
  "confirmRemoveContactsFromMember": "Er du sikker på at du vil slette desse kontaktene frå denne bedrifta? Antal: {{count}}",
  "contactChangeCompanyNotification": "Kontakter som allereie er knytta opp mot ei bedrift vil miste si kobling og bli knytta til denne bedrifta.",
  "contactDetails.inkind.description": "Her ligg all eigeninnsats registrert hos kontakta.",
  "contactList.description": "Legg til medlembredriftens kontaktpersoner. Ønsker du ikke å gjøre det nå, så kan du hoppe over og legge dem til senere.",
  "contacts": "Kontakter",
  "contactsRemovedFromMembersStillActive": "Kontaktene fjernes nå fra medlemmene, men er fortsatt aktive.",
  "couldNotRemoveParticipants": "Klarte ikkje fjerne deltakarar. Prøv på nytt.",
  "createCustomer": "Opprett kunde",
  "dataSavedAutomatically": "Dataen du legg inn blir lagra automatisk.",
  "delete.associate.error": "Kunne ikkje slette desse samarbeidspartnarane. Vennlegst prøv igjen.",
  "delete.associate.modal.title": "Slett desse samarbeidspartnarane frå ressursbasen.",
  "delete.contact.error": "Kunne ikkje slette desse kontaktene. Vennlegst prøv igjen.",
  "delete.contact.modal.title": "Slett desse kontaktene frå ressursbasen",
  "delete.lead.error": "Kunne ikkje slette desse leads. Vennlegst prøv igjen.",
  "delete.lead.modal.title": "Slett desse leads frå ressursbasen.",
  "delete.member.error": "Kunne ikkje slette desse medlemmane. Vennlegst prøv igjen.",
  "delete.member.modal.title": "Slett desse medlemmane frå ressursbasen.",
  "deleteValue": "Slett verdi",
  "editing": "Redigering",
  "eventCount": "Antal events",
  "excel.downloadTemplate": "Last ned mal",
  "excel.downloadTemplateTips": "For å gjøre det enklere med å importere inn data, anbefaler vi at dere laster ned vår Excel-mal",
  "femaleCEO": "Kvinneleg dagleg leiar",
  "femaleChairman": "Kvinneleg styreleiar",
  "femaleFounder": "Kvinneleg gründer",
  "updateDataFromBrreg": "Oppdater data frå Brreg",
  "updateDataFromBrreg.description": "Hent informasjon frå Brønnøysundregistrene",
  "files": "Filer",
  "forcedLiquidation": "Under trangsavvikling",
  "gotoContactPage": "Gå til kontaktsida",
  "gotoDetailPage": "Gå til detaljesida",
  "import": "Importer",
  "import.alreadyInResourceBase": "Disse finnes fra før i ressursbasen, og vil ikke bli opprettet.",
  "import.amount": "Antal: {{ length }} stk",
  "import.invalidOrganizationNumber": "Ugyldige organisasjonsnummer",
  "import.invalidOrganizationNumber.description": "Her får du en liste med hvilke verdier som er ugyldige, hvorfor de er ugyldig, og hvilken rad de ble funnet på.",
  "import.member.noneToImport": "Ingen medlemmer å importere.",
  "import.noneToImport": "Ingen å importere",
  "import.template.associates": "Import-mal for samarbeidspartnarar",
  "import.template.leads": "Import-mal for leads",
  "import.template.members": "Import-mal for medlemmer",
  "importAssociates": "Importer samarbeidspartnarar",
  "importContacts": "Importer kontakter",
  "importLeads": "Importer leads",
  "importMembers": "Importer medlemmar",
  "industry": "Bransje",
  "inkindKeptContactDeleted": "vil beholdes, selv om kontakter blir slettet.",
  "innovationSupport": "Innovasjonsstønad",
  "intro": "Intro",
  "invalid.date": "Ugyldig dato",
  "invalidFileType": "Ugyldig filype, vennlegst velg et Excel-skjema likt malen.",
  "invalidOrgNumber": "Ugyldeg org.nr format.",
  "invoicedDeductible": "Fakturert eigenandel",
  "invoiceNumber": "Fakturanr.",
  "keepExistingValue": "Behold eksisterende verdi",
  "lead": "Lead",
  "leads": "Leads",
  "leads.excelImportError": "Noko gjekk gale under importering av Excel-fila. Det kan være forskjel på ditt Excel-skjema og mal. Last ned mal og prøv igjen.",
  "leads.Imported": "{{ numberOfLeads }} leads importert!",
  "leads.ImportError": "Noko gjekk gale under opprettelse av leads. Vennlegst prøv igjen.",
  "leads.Importing": "Importerer leads...",
  "leads.noneToImport": "Ingen leads å importere",
  "liquidation": "Under avvikling",
  "logo": "Logo",
  "logoLimitationExplanation": "Logofiler må vere anten i .jpg- eller .png-format og kan maks vere 1 MB (kun éin logo per bedrift).",
  "fileUploadLimitationExplanation": "Du kan laste opp følgjande filformat: *.pdf, *.doc, *.docx, *.dot, .xls, .xlsx, med ein maksimal filstorleik på 10 MB per fil.",
  "mainContact": "Hovudkontakt",
  "markedRowsAlreadyRetired": "Markerte rader er allereie utmeldt.",
  "marketValue": "Marknadsverdi",
  "customer": "Kunde",
  "memberFee": "Medlemskontingent",
  "memberFeeDescription": "Her ligg all eigeninnsats registrert på medlemmet på tvers av prosjekt, aktivitetar og eventer.",
  "memberFeeTitle": "Oversikt over medlemsbedrifta sin eigeninnsats",
  "memberInformation": "Medlemsinformasjon",
  "memberProfile": "Medlemsprofil",
  "memberRetiredDescriptionPart1": "Dette medlemmet er meldt ut, utmeldingsdato:",
  "memberRetiredDescriptionPart2": "Medlemmet kan ikkje endrast før det meldast inn igjen",
  "customers": "Kunder",
  "membersMayHaveConnectedContacts": "Disse medlemmene kan ha tilknyttet kontakter.",
  "missing.name": "Namn manglar",
  "missing.type": "Type manglar",
  "nace": "NACE-kode",
  "newContact": "Ny kontakt",
  "noContactsInMember": "Ingen kontakter tilknytta dette medlemmet.",
  "noRowsMarkedRequired": "Ingen rader markert! Minst en rad må være markert for å utføre denne handlingen.",
  "numberOfEmployees": "Antal ansatte",
  "numberOfEmployeesLastYear": "Antal ansatte i fjor",
  "opportunities": "Henvendelser",
  "orderNumber": "Ordrenummer",
  "organization": "Organisering",
  "organizationNumber.invalidFormat": "Ugyldig format på organisasjonsnummer.",
  "participantsRemoved": "Deltakarar blei fjerna",
  "projectCount": "Antal prosjekt",
  "readyForImport": "klar til import",
  "registeredTooMuch": "Registrert motteke for mykje stønad",
  "registratedHours": "Registrerte timar",
  "registration": "Registrering",
  "registration.businessEnterprise": "Reg. Foretaksregisteret",
  "registration.foundation": "Reg. Stiftelsesregisteret",
  "registration.legal": "Reg. Enhetsregisteret",
  "registration.nonProfit": "Reg. Frivillighetsregisteret",
  "registration.vat": "Reg. MVA-registeret",
  "removeAllContactsFromList": "Fjern alle kontakter fra listen",
  "removingParticipants": "Fjerner deltakarar",
  "replaceExistingValue": "Erstatt eksisterende verdi med...",
  "retire.associate.error": "Kunne ikkje melde ut desse medlemmane. Vennlegst prøv igjen.",
  "retire.associate.modal.title": "Meld ut desse samarbeidspartnarane frå ressursbasen.",
  "retire.contact.error": "Kunne ikkje melde ut desse kontaktene. Vennlegst prøv igjen.",
  "retire.contact.modal.title": "Meld ut desse kontaktene frå ressursbasen",
  "retire.lead.error": "Kunne ikkje melde ut desse leads. Vennlegst prøv igjen.",
  "retire.lead.modal.title": "Meld ut desse leads frå ressursbasen.",
  "retire.member.error": "Kunne ikkje melde ut desse medlemmane. Vennlegst prøv igjen.",
  "retire.member.modal.title": "Meld ut disse medlemmane frå ressursbasen.",
  "searchForContacts": "Søk etter kontaktar",
  "selectCompany": "Velg bedrift",
  "sumInnovationSupport": "Sum motteke innovasjonsstønad frå næringshagen",
  "supportIntensity": "Stønadsintensitet",
  "supportMarketValue": "Marknadsverdi på innovasjonsstønadstjenester frå næringshagen",
  "tooMuchSupport": "For mykje støtte",
  "uniqueParticipants": "Unike deltakarar",
  "uniqueParticipantsOfMembers": "Av totalt {{participantsCount}} fordelt på {{membersCount}} medlemmer",
  "import.invalidEmailsFound": "Ugyldege e-postadresser funne. Her får du ei liste over dei ugyldege verdiane, og kva rad dei blei funne på.",
  "import.duplicateEmailsFound": "Duplikate e-postadresser funne. Her får du ei liste over dei ugyldege verdiane, og kva rad dei er funne på.",
  "import.existsInResourceBase": "Desse fins frå før i ressursbasen, og vil ikkje bli oppretta.",
  "import.invalidOrgNoFound": "Ugyldege organisasjonsnummer funne. Her får du ei liste over dei ugyldege verdiane, og kva rad dei blei funne på.",
  "import.contact.readyForImport": "{{ contacts }} kontakt(er) klar for import, og {{ leads }} lead(s) (bedrifter).",
  "import.template.contacts": "Import-mal for kontakter",
  "import.contact.noneToImport": "Ingen kontakter å importere",
  "showDuplicateEmails": "Vis duplikate e-postadresser",
  "showInvalidOrgNumbers": "Vis ugyldege organisasjonsnummer",
  "showExisting": "Vis eksisterande",
  "showInvalidEmails": "Vis ugyldege epostadresser",
  "selectMember": "Vel medlem",
  "memberContacts": "Kontakter tilknytta dette medlemmet:",
  "noMemberContacts": "Dette medlemmet har ingen kontakter å anbefale kurs til",
  "contactsAlreadyRecommended": "Følgande kontakter har allereie fått anbefalt dette kurset:"
}
